'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import Step from './Step'

const HowItWorksSection = () => {
  const translate = useTranslate('item_verification.how_it_works')

  return (
    <section className="item-verification__how-it-works" data-testid="howitworks">
      <div className="item-verification__how-it-works-content">
        <h2 className="item-verification__how-it-works-title">{translate('title')}</h2>
        <div className="item-verification__how-it-works-steps" role="list">
          <Step index={1} />
          <Step index={2} />
          <Step index={3} />
          <Step index={4} />
        </div>
      </div>
    </section>
  )
}

export default HowItWorksSection
